import { render, staticRenderFns } from "./RescueOfWorldNet.vue?vue&type=template&id=e2e6ca4a&scoped=true&"
import script from "./RescueOfWorldNet.vue?vue&type=script&lang=js&"
export * from "./RescueOfWorldNet.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfWorldNet.vue?vue&type=style&index=0&id=e2e6ca4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e6ca4a",
  null
  
)

export default component.exports